export const LightBoxPopoverCircleStyle = {
  borderRadius: "100%",
  display: "inline-block",
  width: "24px",
  height: "24px",
  position: "relative",
};

export const LightBoxPopoverCircleNumberStyle = {
  position: "absolute",
  left: 0,
  top: "1px",
  width: "24px",
  height: "24px",
  textAlign: "center",
};
